import { z } from 'zod';
export const RoleSchema = z.enum(['ADMIN', 'CONSULTOR', 'ANALISTA', 'LECTURA', 'CONTABILIDAD']);
export const RoleLabel = {
    ADMIN: 'Administrador',
    CONSULTOR: 'Consultor',
    ANALISTA: 'Analista',
    LECTURA: 'Solo lectura',
    // Gestoría externa: solo facturación (emitidas/recibidas) y contabilidad, en lectura.
    CONTABILIDAD: 'Contabilidad',
};
export const LoginRequestSchema = z.object({
    email: z.string().email('Email no válido'),
    password: z.string().min(1, 'Introduce tu contraseña'),
    /** Código TOTP de 6 dígitos si el usuario tiene MFA activo. */
    mfaCode: z.string().min(6).max(8).optional(),
    /** Código de recuperación si el usuario perdió el dispositivo. */
    recoveryCode: z.string().min(6).max(20).optional(),
});
/**
 * Posibles respuestas del login:
 * - { user }: login completo.
 * - { mfaRequired: true }: el usuario tiene MFA activo y debe reintentar
 *   con mfaCode (o recoveryCode).
 * - { mfaEnrollmentRequired: true }: el usuario debe configurar MFA antes de
 *   poder usar el sistema (porque su rol está en enforceMfaRoles del bufete).
 *   El cliente debe redirigir a /settings/security tras un cambio de sesión.
 */
export const LoginChallengeSchema = z.union([
    z.object({ mfaRequired: z.literal(true) }),
    z.object({ mfaEnrollmentRequired: z.literal(true) }),
]);
export const UserLocaleSchema = z.enum(['ES', 'EN', 'PT']);
export const SessionUserSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    fullName: z.string(),
    role: RoleSchema,
    mustChangePassword: z.boolean(),
    isLawyer: z.boolean(),
    /** F40 — Idioma preferido del usuario. */
    locale: UserLocaleSchema,
});
export const LoginResponseSchema = z.object({
    user: SessionUserSchema,
});
export const ChangePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Introduce tu contraseña actual'),
    newPassword: z
        .string()
        .min(12, 'La nueva contraseña debe tener al menos 12 caracteres')
        .max(128, 'La nueva contraseña es demasiado larga'),
    confirmPassword: z.string().min(1, 'Confirma la nueva contraseña'),
})
    .refine((data) => data.newPassword === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Las contraseñas no coinciden',
})
    .refine((data) => data.newPassword !== data.currentPassword, {
    path: ['newPassword'],
    message: 'La nueva contraseña debe ser diferente de la actual',
});
//# sourceMappingURL=auth.js.map